<template>
  <div>
    <v-container>
      <template>
        <v-treeview
          selectable
          v-model="auth"
          selected-color="blue"
          :items="filtredAuthTree"
        ></v-treeview>
        <center class="empty-auth" v-if="filtredAuthTree.length==0" >Önce Firmaya Kullanıma Yetki Verilmeli..</center>
      </template>
      <hr />
      <v-btn v-if="filtredAuthTree.length>0" color="blue darken-1" style="float: right;" text @click="save()">
        değişiklikleri kaydet
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import * as userReq from "../../request/user.js";
import { mapState } from "vuex";
export default {
  name: "AuthTable",
  props: ["user", "company", "popUpStatus"],
  data() {
    return {
      auth: null,
    };
  },
  methods: {
    treeFilter(tree, checkList) {
      function getNodes(result, object) {
        if (checkList.includes(object.id)) {
          result.push(object);
          return result;
        }
        if (Array.isArray(object.children)) {
          const children = object.children.reduce(getNodes, []);
          if (children.length) result.push({ ...object, children });
        }
        return result;
      }
      return tree.reduce(getNodes, []);
    },
    onCreate() {
      let userComapny = this.user.tUserCompanies.filter(
        (relation) => relation.companyId == this.company
      );
      this.auth = userComapny[0].authPermission;
      //this.availablePlan = userComapny[0].tCompany.subscriptionPlan;
    },
    save() {
      userReq
        .updateUserAuth(this.user.id, this.company, this.auth)
        .then((response) => {
          if (response.data.data.value == 1) {
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "success",
              text: "Kaydedildi",
              timeout: 1500,
            };
            this.$emit("refresh");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.onCreate();
  },
  computed: {
    ...mapState(["gates"]),
    availablePlan() {
      let userComapny = this.user.tUserCompanies.filter(
        (relation) => relation.companyId == this.company
      );
      return userComapny[0] ? userComapny[0].tCompany.subscriptionPlan : [];
    },
    filtredAuthTree() {
      return this.treeFilter(this.gates, this.availablePlan)
    }
  },
  watch: {
    popUpStatus() {
      this.onCreate();
    },
  },
};
</script>

<style scoped>
.empty-auth {
  margin: 8% 0;
  color: rgb(126, 126, 126);
}
</style>
